module.exports = __webpack_public_path__ + "static/media/turkey.30802ce6.svg";